let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
  try {
    // Mirror cart-update pubsub events to a DOM CustomEvent so other snippets
    // that listen for a document-level 'cart:updated' event will receive updates
    // without requiring changes in multiple modules.
    if (eventName === 'cart-update' && typeof document !== 'undefined') {
      const ev = new CustomEvent('cart:updated', { detail: { cart: data && data.cartData ? data.cartData : data } });
      document.dispatchEvent(ev);
    }
  } catch (e) {
    // Fail silently; pubsub should not break page scripts
  }
}
